module.exports = __webpack_public_path__ + "public/Icons/youtube.png?c6280394";